export default function Loader({ message = "Loading..." }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-md">

      <div className="flex flex-col items-center gap-4">

        <div className="relative w-24 h-24">

<div className="absolute inset-0 rounded-full border-4 border-transparent border-t-blue-600 animate-spin-pulse"></div>
          <img
            src="/Images/TriloLogo_TRSP.png"
            className="
    absolute inset-4 w-16 h-16 object-contain rounded-full
    animate-logoFloat animate-logoGlow animate-logoPulse
  "
          />
        </div>

        <p className="text-sm font-medium text-white/90 animate-pulse tracking-wide drop-shadow">
          {message}
        </p>

      </div>

    </div>
  );
}
